// extracted by mini-css-extract-plugin
export default {"iframe-wrapper":"style_iframe-wrapper__bAIQa"};